<template>
  <layout-main-inner>
    <el-button
      slot="action"
      type="primary"
      @click="addRow">新增服务</el-button>
    <layout-card-wrap hasHeaderSlot>
      <template slot="form">
        <goods-status-select v-model="config.status" />
        <el-input
          v-model="config.servName"
          placeholder="请输入合作服务名称"
          clearable=""
          style="width: 240px;margin-left: 10px;"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="服务名称"
          prop="servName"
          min-width="160"> </el-table-column>
        <el-table-column
          label="分类"
          min-width="80"
          prop="className"> </el-table-column>
        <el-table-column
          label="机构名称"
          prop="servOrgName"
          min-width="140"> </el-table-column>
        <el-table-column
          label="咨询次数"
          prop="consultCount"
          min-width="80"> </el-table-column>
        <el-table-column
          label="优先级"
          prop="sort"
          min-width="80"> </el-table-column>
        <el-table-column
          label="状态"
          width="80"
          prop="status"
          :formatter="row => row.status === 1 ? '已上架' : '已下架'"></el-table-column>
        <el-table-column
          label="操作"
          :resizable="false"
          width="110">
          <template slot-scope="{row}">
            <el-button
              type="text"
              @click="updateRow(row)">编辑</el-button>
            <el-dropdown>
              <el-button
                type="text"
                style="margin-left: 10px;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  :disabled="row.status === 1"
                  @click.native="onsale(row, 1)">上架服务</el-dropdown-item>
                <el-dropdown-item
                  :disabled="row.status === 0"
                  @click.native="onsale(row, 0)">下架服务</el-dropdown-item>
                <el-dropdown-item @click.native="showDetail(row)">查看服务详情</el-dropdown-item>
                <el-dropdown-item @click.native="deleteRow(row)">删除服务</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </layout-card-wrap>

    <edit-serv-modal
      ref="service"
      @fetch="fetchList" />

    <detail-drawer ref="detail" />
  </layout-main-inner>
</template>
<script>
import GoodsStatusSelect from '../goods/busi/goods-status-select.vue'
import DetailDrawer from './service/detail-drawer.vue'
import EditServModal from './service/edit-serv-modal.vue'
import OrgService from '@/service/org-service'
export default {
  name: 'ServiceList',
  components: { EditServModal, DetailDrawer, GoodsStatusSelect },
  data() {
    return { loading: true, list: [], total: 0, config: { pageNum: 1, pageSize: 10, servName: '', status: null }}
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    showDetail(row) {
      this.$refs.detail.fetch({ id: row.id })
    },
    updateRow(row) {
      this.$refs.service.init({ ...row })
    },
    addRow() {
      this.$refs.service.init()
    },
    deleteRow(row) {
      this.$confirm('您确定删除该服务产品?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          OrgService.deleteserv({ id: row.id })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    onsale(row, status) {
      const title = status === 1 ? '上架' : '下架'
      this.$confirm(`您确定${title}该服务产品?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          OrgService.updateserv({ id: row.id, status })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if (result === 0) {
                this.$message.success(title + '成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      OrgService.getservs({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, total, records } = res.data
          if ([0, 13].includes(result)) {
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
